<script lang="ts">
  export interface EmptyStateDashedProps {
    icon: IconValues
    text: string
  }
</script>
<script setup lang="ts">
  import { type IconValues } from '@gat-ship/icons'

  const props = defineProps<EmptyStateDashedProps>()
</script>

<template>
  <button
    type="button"
    class="border-border hover:bg-accent focus:outline-primary dark:focus:outline-primary relative block w-full cursor-pointer rounded-lg border-2 border-dashed p-12 text-center hover:border-neutral-300 focus:outline-2 focus:outline-offset-2 dark:border-white/15 dark:hover:border-white/25"
  >
    <gat-icon
      class="text-soft dark:text-soft mx-auto size-12"
      :icon="icon"
      :stroke-width="1.5"
    />
    <span class="mt-2 block text-sm font-medium">{{ text }}</span>
  </button>
</template>
